import { generateClient } from '@maui/api-helpers'
import { validation } from './endpoints'

export const MSVApi = generateClient({
  validation,
}, {
  name: 'MSVApi',
  defaultHeaders: {
    accept: 'application/json',
  },
  onResponse: async res => {
    const data = await res.json()
    if (!res.ok) {
      const e = new Error(`MSVApi - ${res.status}`)
      e.data = data
      throw e
    }
    return data
  }
})
